import { IAnchor } from './anchor';
import { IEquatable } from './entity';
import { Headings } from './headings';

export type IComponent = {
  id?: IEquatable;
  blockType?: string;
  schema?: string; // deprecated
  anchor?: IAnchor;
  seoWeight?: Headings;
  [key: string]: unknown;
};
